<ngx-datatable
  class="none md-block material noshadow expandable payment-automatic"
  [cssClasses]="{
    pagerLeftArrow: 'icon-chevron-left',
    pagerRightArrow: 'icon-chevron-right',
    pagerPrevious: 'icon-arrow-left-double',
    pagerNext: 'icon-arrow-right-double'
  }"
  [rows]="tableRows"
  [columns]="tableColumns"
  columnMode="force"
  [headerHeight]="60"
  [footerHeight]="tableRows.length > 5 ? 'auto' : 0"
  rowHeight="auto"
  [scrollbarH]="true"
  [limit]="5"
>
</ngx-datatable>

<ds-table
  class="block md-none"
  [rows]="tableRows"
  [columns]="tableColumns"
  [headerHeight]="60"
  [tableClasses]="'action-row'"
>
</ds-table>
